import React from 'react';

export const STORE_NAME = 'Laurenti Apparel';
export const LOGO_SRC = '/laurenti-logo.png';

function BrandLogo({ className = '', ...props }) {
  return (
    <img
      src={LOGO_SRC}
      alt={STORE_NAME}
      className={`brand-logo${className ? ` ${className}` : ''}`}
      draggable="false"
      {...props}
    />
  );
}

export default BrandLogo;
